var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C6.3446 12 6.19556 11.9383 6.08568 11.8284C5.97579 11.7185 5.91406 11.5695 5.91406 11.4141V0.585938C5.91406 0.430537 5.97579 0.281502 6.08568 0.171617C6.19556 0.0617325 6.3446 0 6.5 0C6.6554 0 6.80444 0.0617325 6.91432 0.171617C7.02421 0.281502 7.08594 0.430537 7.08594 0.585938V11.4141C7.08594 11.5695 7.02421 11.7185 6.91432 11.8284C6.80444 11.9383 6.6554 12 6.5 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9141 6.58594H1.08594C0.930537 6.58594 0.781502 6.52421 0.671617 6.41432C0.561733 6.30444 0.5 6.1554 0.5 6C0.5 5.8446 0.561733 5.69556 0.671617 5.58568C0.781502 5.47579 0.930537 5.41406 1.08594 5.41406H11.9141C12.0695 5.41406 12.2185 5.47579 12.3284 5.58568C12.4383 5.69556 12.5 5.8446 12.5 6C12.5 6.1554 12.4383 6.30444 12.3284 6.41432C12.2185 6.52421 12.0695 6.58594 11.9141 6.58594Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.00e3ef654dffe98727959b674e7114c6.svg";
export { ForwardRef as ReactComponent };